module.exports = __webpack_public_path__ + "img/img_left.788541f6.jpg";